import Link from "next/link";
import { useRouter } from "next/router";
import useSWR from "swr";

import { useMemo, useState } from "react";

import { format, parseJSON } from "date-fns";
import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import useAuthentication from "hooks/useAuthentication";
import { baseFetcher } from "utils/baseFetcher";

import { entityEarningsAlertUrl } from "../EntityPageAnnoucements/EntityPageEarningsAlertList";
import EarningsAlertModal from "../EntityPageAnnoucements/EntityPageEarningsAlertList/EarningsAlertModal";

export default function EarningsAlertWidget({
  containerClassName,
  headerClassName,
}: {
  containerClassName?: string;
  headerClassName?: string;
}) {
  const router = useRouter();
  const { authenticated } = useAuthentication();

  const slug = router.query.slug as string;
  const { data, isLoading } = useSWR(
    authenticated ? entityEarningsAlertUrl(slug, 1, 1) : null,
    baseFetcher
  );
  const [itemId, setItemId] = useState<string | null>(null);

  const item = useMemo(() => {
    if (isLoading) return [];

    return data?.data?.filter((item: any) => {
      return (
        new Date(item.createdAt).getTime() >
        new Date().getTime() - 4 * 30 * 24 * 60 * 60 * 1000
      );
    });
  }, [data?.data, isLoading]);

  if (!item?.length || router.query.tab === "earnings-alerts" || isLoading) {
    return null;
  }

  return (
    <>
      <CustomCard className={twMerge("!p-[15px]", containerClassName)}>
        <p className={twMerge("font-medium", headerClassName)}>
          Latest Earnings/Operating Data
        </p>
        {item?.map((item: any) => {
          return (
            <div key={item.id} className="flex flex-col text-[13px]">
              <span className=" text-shady-gray">
                {format(parseJSON(item.createdAt), "dd MMM yyyy HH:mm")}
              </span>
              <div
                onClick={() => setItemId(item.id)}
                className="hover:text-smart-teal cursor-pointer"
              >
                {item.title}
              </div>
            </div>
          );
        })}
        <div className="mt-[15px]">
          <Link
            href={`/entities/${slug}/announcements?tab=earnings-alerts`}
            className="text-[14px] font-bold text-smart-teal hover:text-dark-teal"
          >
            {"View More »"}
          </Link>
        </div>
      </CustomCard>
      {itemId && (
        <EarningsAlertModal id={itemId} onClose={() => setItemId(null)} />
      )}
    </>
  );
}
